var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 40,
    viewBox: "0 0 157 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logo-win-sm 1",
    clipPath: "url(#clip0_315_1040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_1040",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 157,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M157 0H0V40H157V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_1040)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M147.703 19.5809V24.7871L151.435 20.5698C150.268 19.9934 148.999 19.6573 147.703 19.5809Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M147.703 26.5932V31.32L154.825 23.3067C154.166 22.4755 153.382 21.7554 152.5 21.1733L147.703 26.5932Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M155.523 24.3192L147.703 33.1161V37.835L156.801 27.5605C156.567 26.4125 156.135 25.3153 155.525 24.3192",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    d: "M147.791 39.5415C150.288 39.3683 152.627 38.2424 154.336 36.3911C156.045 34.5398 156.997 32.101 156.999 29.5669C156.999 29.432 156.985 29.3007 156.98 29.1672L147.791 39.5415Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M146.518 19.5809C144.002 19.7291 141.637 20.8453 139.908 22.7012C138.178 24.5571 137.215 27.0121 137.215 29.5637C137.215 32.1153 138.178 34.5703 139.908 36.4262C141.637 38.2821 144.002 39.3984 146.518 39.5465V19.5809Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M57.4672 0.453522V24.4684C57.4672 33.8632 50.9564 40 41.0783 40C35.7667 40 31.5006 38.1823 28.7329 35.0745C25.9637 38.1823 21.699 40 16.3861 40C6.50936 40 0 33.8632 0 24.4684V0.453522H12.12V22.8022C12.0779 23.5098 12.1846 24.2184 12.433 24.8812C12.6814 25.5439 13.0658 26.1458 13.5609 26.6471C14.056 27.1483 14.6505 27.5376 15.3051 27.789C15.9597 28.0405 16.6596 28.1485 17.3585 28.1059C20.5012 28.1059 22.6743 25.984 22.6743 22.8022V0.453522H34.7943V22.8022C34.7519 23.5098 34.8583 24.2184 35.1065 24.8812C35.3547 25.544 35.739 26.146 36.234 26.6473C36.729 27.1486 37.3234 27.5378 37.9781 27.7893C38.6327 28.0407 39.3326 28.1486 40.0314 28.1059C43.1755 28.1059 45.3472 25.984 45.3472 22.8022V0.453522H57.4672Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M80.7269 0.90918H68.6055V39.5465H80.7269V0.90918Z",
    fill: "#E0007A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 7",
    d: "M130.108 14.4695V39.5451H117.988V18.5605C117.988 14.542 115.518 11.8941 111.627 11.8941C107.512 11.8941 104.743 14.6209 104.743 18.7112V39.5451H92.623V0.909191H104.743V4.31775C106.201 2.89459 107.925 1.77979 109.813 1.03845C111.701 0.297116 113.717 -0.0559058 115.741 1.96882e-06C124.345 1.96882e-06 130.108 5.75724 130.108 14.4695Z",
    fill: "#E0007A"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWin);
export default __webpack_public_path__ + "static/media/logo-win.d96dbc97a12fec7a8736587fe1610b05.svg";
export { ForwardRef as ReactComponent };